export default "__VITE_ASSET__DT1R3ko7__"